/**
 * Combat-round tracker types.
 *
 * Spec: `.kiro/specs/active-effects-round-tracker/design.md` — Data Models.
 *
 * Pure types + budget constants. No logic.
 */

export type ActiveEffectSourceKind =
  | 'aim'
  | 'reload'
  | 'sprint'
  | 'sustained-power'
  | 'combat-state-mirror'
  | 'temporary-effect'
  | 'per-round-damage';

export interface DamagePerRound {
  formula: string;
  damageType: 'wounds' | 'fatigue' | 'characteristic';
  characteristicTarget?: string;
  ignoresArmour: boolean;
  ignoresToughness: boolean;
  description: string;
}

export interface ActiveEffect {
  id: string;
  label: string;
  source: string;
  sourceKind: ActiveEffectSourceKind;
  roundsRemaining: number | null;
  damagePerRound?: DamagePerRound;
  createdAt: number;
}

export interface ActionCounters {
  halfActionsUsed: number;
  fullActionsUsed: number;
  reactionsUsed: number;
  freeActionsUsed: number;
}

export const HALF_ACTION_BUDGET = 2;
export const FULL_ACTION_BUDGET = 1;
export const REACTION_BUDGET = 1;
